import { IonCol, IonFooter, IonGrid, IonImg, IonRow } from '@ionic/react';
import React from 'react';
import HtmlParseComponent from '../../../pages/Menu/htmlParsingComponent';
import './Footer.scss';

const Footer = (props: any) => {
  const { contentStackData } = props;
  const footerData =
    contentStackData &&
    contentStackData.data &&
    contentStackData.data.getWebContent &&
    contentStackData.data.getWebContent.webFooter &&
    contentStackData.data.getWebContent.webFooter.entries[0];
  return (
    <IonFooter class="sni-footer-wrapper">
      {footerData ? (
        <IonGrid>
          <IonRow>
            <IonCol size="2">
              <IonImg className="footer-logo" src={footerData.logo.url} />
            </IonCol>
            <IonCol size="4">{footerData.copyRight}</IonCol>
            <IonCol size="4" class="ion-text-end">
              <HtmlParseComponent richText={footerData.policyVersion} isRichText={false} />
            </IonCol>
            <IonCol size="2" class="ion-text-end">
              {footerData.socialLinks.map((link: any, index: number) => (
                <a className="social-icon" key={index} target="_blank" href={link.hrefLink || ''}>
                  <IonImg src={link.url} />
                </a>
              ))}
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : null}
    </IonFooter>
  );
};

export default Footer;
